import React from 'react';

import classes from './empty-list.module.scss';

function EmptyList({ dict: { empty } }: { dict: { empty: string } }) {
  return (
    <article className={classes.nodataView}>
      <div className={classes.viewBox}>
        <div className={classes.icBox}>
          <i className={`${classes.ic} ${classes.icNodata}`}></i>
        </div>
        <div className={classes.msgBox}>{empty}</div>
      </div>
    </article>
  );
}

export default EmptyList;
